export enum OfferRequestAction {
  Accept = 'accept',
  Reject = 'reject',
}
